
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"11","fill":"url(#paint0_linear_27_11996)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.222 10.556c0-.573-.27-1.083-.691-1.408L12 6l2.47 3.148a1.778 1.778 0 102.853 1.207L20 9.91 17 17H7L4 9.91l2.678.445a1.778 1.778 0 103.544.2z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_27_11996","x1":"4","y1":"19.5","x2":"21","y2":"3","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#F9A207"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFD68D"}})])])])
          )
        }
      }
    